module.exports = __webpack_public_path__ + "img/new-open-sns-pc.69669de.png";